import { createRef, RefObject } from 'react';
import * as THREE from 'three';
import { typedObjKeys } from '../helpers.ts';
import { HorseName, Position, stablesData } from './consts.ts';

export const HORSES = {
  // ada: { type: 'ada', modelURL: '/racing-game//models/horses-transformed/Cardano-transformed.glb' },
  // ton: { type: 'ton', modelURL: '/racing-game//models/horses-transformed/Ton-transformed.glb' },
  // doge: { type: 'doge', modelURL: '/racing-game//models/horses-transformed/Dogecoin-transformed.glb' },
  // xrp: { type: 'xrp', modelURL: '/racing-game//models/horses-transformed/Ripple-transformed.glb' },
  // sol: { type: 'sol', modelURL: '/racing-game//models/horses-transformed/Solana-transformed.glb' },
  // bnb: { type: 'bnb', modelURL: '/racing-game//models/horses-transformed/Binance-transformed.glb' },
  // eth: { type: 'eth', modelURL: '/racing-game//models/horses-transformed/Ethereum-transformed.glb' },
  // btc: { type: 'btc', modelURL: '/racing-game//models/horses-transformed/Bitcoin-transformed.glb' },

  popcat: {
    modelURL: '/racing-game/models/horses_with_characters/opt/popcat-transformed.glb',
  },
  brett: {
    modelURL: '/racing-game/models/horses_with_characters/opt/brett-transformed.glb',
  },
  floki: {
    modelURL: '/racing-game/models/horses_with_characters/floki-transformed.glb',
  },
  wif: {
    modelURL: '/racing-game/models/horses_with_characters/opt/wif-transformed.glb',
  },
  bonk: {
    modelURL: '/racing-game/models/horses_with_characters/opt/bonk-transformed.glb',
  },
  pepe: {
    modelURL: '/racing-game/models/horses_with_characters/opt/pepe-transformed.glb',
  },
  shib: {
    modelURL: '/racing-game/models/horses_with_characters/opt/shib-transformed.glb',
  },
  doge: {
    modelURL: '/racing-game/models/horses_with_characters/opt/doge-transformed.glb',
  },

  // doge: {
  //   modelURL:
  //     '/racing-game/models/horses_with_characters/opt/doge-transformed.glb',
  // },
  // virtual: {
  //   modelURL:
  //   '/racing-game/models/horses_with_characters/virtual-transformed.glb',
  // },
  // shib: {
  //   modelURL:
  //     '/racing-game/models/horses_with_characters/opt/shib-transformed.glb',
  // },
  // aixbt: {
  //   modelURL:
  //     '/racing-game/models/horses_with_characters/aixbt-transformed.glb',
  // },
  // pepe: {
  //   modelURL:
  //     '/racing-game/models/horses_with_characters/opt/pepe-transformed.glb',
  // },
  // vader: {
  //   modelURL:
  //   '/racing-game/models/horses_with_characters/vader-transformed.glb',
  // },
  // brett: {
  //   modelURL:
  //     '/racing-game/models/horses_with_characters/opt/brett-transformed.glb',
  // },
  // lunai: {
  //   modelURL:
  //     '/racing-game/models/horses_with_characters/lunai-transformed.glb',
  // },
} as const;

export const horseNames = Object.keys(HORSES) as HorseName[];

export type StableName = 'A' | 'B';

export const stablesNames = Object.keys(stablesData) as StableName[];

/*export type ActionName =
  | 'Idle.001'
  | 'Idle_002'
  | 'Idle_003'
  | 'Sprint'
  | 'Walk';*/

/*const IDLE_ACTION: ActionName[] = [
  'Idle.001',
  'Idle_002',
  'Idle_003',
  'Sprint',
  'Walk',
];*/

export type Horse = {
  id: number;
  name: HorseName;
  groupRef: RefObject<THREE.Group | null>;
  position: Position;
  // action?: ActionName;
};

export const horses: Horse[] = typedObjKeys(HORSES).map((name, index) => ({
  id: index + 1,
  name,
  // eslint-disable-next-line react-x/no-create-ref
  groupRef: createRef(),
  position: [(index - 8 / 2) * 22 + 11, 14, 0],
}));
